// test2005
(2005 && 0);
